/**
 * Human-readable labels for backend status enums.
 *
 * API values are unchanged; this is presentation-only.
 */
const STATUS_LABELS: Readonly<Record<string, string>> = {
  // Identity
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
  SUSPENDED: 'Suspended',

  // Onboarding
  REGISTERED: 'Registered',
  PROFILE_COMPLETE: 'Profile complete',
  CONSENT_COMPLETE: 'Consent complete',
  BANK_ACCOUNT_ADDED: 'Bank account added',
  ONBOARDING_COMPLETE: 'Onboarding complete',
  COMPLETED: 'Completed',

  // Subscriptions / applications
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  UNDER_REVIEW: 'Under review',
  CHANGES_REQUESTED: 'Changes requested',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  ACCEPTED: 'Accepted',
  AWAITING_MANDATE: 'Direct debit setup required',
  MANDATE_ACTIVE: 'Direct debit active',
  CANCELLED: 'Cancelled',

  // Mandates
  PENDING: 'Pending',
  PENDING_ACTIVATION: 'Pending activation',
  AWAITING_ACTIVATION_PAYMENT: 'Awaiting activation payment',
  ACTIVATION_DECLARED: 'Activation declared',

  // Billing / payments
  SCHEDULED: 'Scheduled',
  DUE: 'Due',
  AWAITING_CUSTOMER_AUTHORIZATION: 'Authorization required',
  AWAITING_AUTHORIZATION: 'Authorization required',
  PROCESSING: 'Processing',
  PAID: 'Paid',
  OVERDUE: 'Overdue',
  SUCCEEDED: 'Successful',
  SUCCESSFUL: 'Successful',
  FAILED: 'Failed',
  EXPIRED: 'Expired',
  OTP_SENT: 'OTP sent',
  LINK_OPENED: 'Link opened',
  OTP_EXPIRED: 'OTP expired',

  // Notifications / health
  QUEUED: 'Queued',
  SENT: 'Sent',
  DELIVERED: 'Delivered',
  HEALTHY: 'Healthy',
  UNHEALTHY: 'Unhealthy',
  CONFIRMED: 'Confirmed',
};

function titleCaseWords(value: string): string {
  return value
    .split(' ')
    .map((word) =>
      word.length === 0 ? word : `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`,
    )
    .join(' ');
}

/** Convert a backend status code to a readable label. */
export function formatStatusLabel(status: string): string {
  const known = STATUS_LABELS[status];
  if (known !== undefined) {
    return known;
  }

  return titleCaseWords(status.replace(/_/g, ' '));
}
